import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import AdminPendingApproval from './pages/AdminPendingApproval';
import AccessRequests from './pages/AccessRequests';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Advertisers from './pages/Advertisers';
import Affiliates from './pages/Affiliates';
import SignupProfile from './pages/SignupProfile';
import Overlap from './pages/Overlap';
import Contacts from './pages/Contacts';
import Settings from './pages/Settings';
import Discovery from './pages/Discovery';
import Reporting from './pages/Reporting';
import Automations from './pages/Automations';
import Management from './pages/Management';
import AdminLayout from './components/AdminLayout';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) {
    return <div className="min-h-screen bg-slate-900" />;
  }
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-slate-900">
          <Routes>
            {/* Public Route - Admin Login */}
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/access-request" element={<Navigate to="/login" replace />} />
            <Route path="/pending-approval" element={<AdminPendingApproval />} />
            
            {/* Protected Routes - Admin Dashboard */}
            <Route path="/" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Dashboard />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Dashboard />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/users" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Users />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/access-requests" element={
              <ProtectedRoute>
                <AdminLayout>
                  <AccessRequests />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/advertisers" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Advertisers />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/advertisers/:id" element={
              <ProtectedRoute>
                <AdminLayout>
                  <SignupProfile type="advertiser" />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/affiliates" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Affiliates />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/affiliates/:id" element={
              <ProtectedRoute>
                <AdminLayout>
                  <SignupProfile type="affiliate" />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/overlap" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Overlap />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/contacts" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Contacts />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Settings />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/discovery" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Discovery />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/reporting" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Reporting />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/automations" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Automations />
                </AdminLayout>
              </ProtectedRoute>
            } />
            <Route path="/management" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Management />
                </AdminLayout>
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
